import React from "react";

const RightArrowIcon = () => {
  return (
    <div style={{ padding: "0 7.5px 0 7.5px" }}>
      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.601452 4.99902L0.601703 4.99903L0.601689 4.99194C0.601409 4.84877 0.65132 4.71 0.742786 4.59972C0.742807 4.5997 0.742829 4.59967 0.742851 4.59964L4.31226 0.321651L4.31234 0.321552C4.41655 0.196328 4.56633 0.117551 4.72873 0.102596C4.89114 0.0876406 5.05283 0.137738 5.17822 0.241834C5.30361 0.345926 5.38244 0.495478 5.3974 0.657575C5.41236 0.819622 5.36228 0.980985 5.25814 1.10619C5.2581 1.10623 5.25807 1.10626 5.25804 1.1063L2.05987 4.92796L2.00713 4.99098L2.05874 5.05493L5.14286 8.8768L5.14309 8.87709C5.19408 8.93979 5.23215 9.01194 5.25512 9.08938C5.27809 9.16682 5.28551 9.24802 5.27696 9.32833C5.2684 9.40864 5.24404 9.48647 5.20527 9.55736C5.1665 9.62824 5.11407 9.69078 5.05101 9.74138L5.05093 9.74128L5.04713 9.74466C4.98401 9.80081 4.90995 9.84334 4.82959 9.86959C4.74923 9.89583 4.66431 9.90521 4.58015 9.89715C4.49599 9.88909 4.4144 9.86376 4.34051 9.82275C4.26661 9.78174 4.20201 9.72593 4.15073 9.65883L4.15075 9.65881L4.14913 9.6568L0.703583 5.38191C0.628048 5.26911 0.59211 5.13444 0.601452 4.99902Z"
          fill="#AEAEAE"
          stroke="white"
          strokeWidth="0.2"
        />
      </svg>
    </div>
  );
};

export default RightArrowIcon;
